import {get} from './request'
import { serverApiUrl } from '../config/server';

export default (typeId)=>{
    return get(`${serverApiUrl}/type/${typeId}/TypeModule`).then(res=>{
        let modules = res.data.data;
        return modules;
    })
}